import React from 'react';
import PropTypes from 'prop-types';

var Chart = function Chart(_ref) {
  var title = _ref.title,
    className = _ref.className,
    titleClassName = _ref.titleClassName,
    svgClassName = _ref.svgClassName,
    children = _ref.children,
    height = _ref.height,
    width = _ref.width;
  return /*#__PURE__*/React.createElement("div", {
    className: className,
    "aria-hidden": "true"
  }, title && /*#__PURE__*/React.createElement("h4", {
    className: titleClassName
  }, title), /*#__PURE__*/React.createElement("svg", {
    className: svgClassName,
    height: height,
    width: width
  }, children));
};
Chart.propTypes = process.env.NODE_ENV !== "production" ? {
  children: PropTypes.node,
  className: PropTypes.string,
  height: PropTypes.node,
  svgClassName: PropTypes.string,
  title: PropTypes.node,
  titleClassName: PropTypes.string,
  width: PropTypes.node,
  // eslint-disable-next-line zillow/react/no-unused-prop-types
  legend: PropTypes.bool
} : {};
Chart.defaultProps = {
  title: '',
  className: 'rd3-basic-chart',
  svgClassName: 'rd3-chart',
  titleClassName: 'rd3-chart-title',
  legend: false
};
var Chart$1 = Chart;

export { Chart$1 as default };
